import { Link } from "react-router-dom";

const CONTACT_DETAILS = [
  {
    icon: "ri-map-pin-line",
    label: "Adresse",
    value: "Hallesche Str. 4, 66121 Saarbrücken",
  },
  {
    icon: "ri-phone-line",
    label: "Telefon",
    value: "0681 / 830 582 90",
    href: "tel:+4968183058290",
  },
  {
    icon: "ri-mail-line",
    label: "E-Mail",
    value: "hv@fiwo-gmbh.de",
    href: "mailto:hv@fiwo-gmbh.de",
  },
];

export default function BusinessCard() {
  return (
    <main className="min-h-screen w-full bg-background-50 flex items-center justify-center px-4 md:px-10 py-10 md:py-16">
      <div className="w-full max-w-3xl animate-fade-up">
        <div className="rounded-lg overflow-hidden border border-background-200 bg-background-100">
          <div className="w-full bg-background-200">
            <img
              src="bilder/fiwo-collage.webp"
              alt="Financial World Vertriebs GmbH – Themenwelten und Marken"
              title="Financial World Vertriebs GmbH Saarbrücken"
              className="w-full h-auto"
              onError={(event) => {
                const img = event.currentTarget;
                if (img.dataset.fallbackApplied) return;
                img.dataset.fallbackApplied = "true";
                img.src =
                  "https://storage.helloreaddy.io/project_files/65069bc4-023d-4bd7-9f48-82bb81d7e3fb/96472f1d-f1b7-41f7-a2b4-50fb1d969605_compressed_Vorschlag-3.webp";
              }}
            />
          </div>

          <div className="flex flex-col p-8 md:p-12">
            <div className="flex flex-col leading-none">
              <span className="font-heading text-2xl md:text-3xl tracking-tight text-foreground-950">
                Financial World
              </span>
              <span className="mt-2 text-[11px] uppercase tracking-[0.24em] text-foreground-500">
                Vertriebs GmbH
              </span>
            </div>

            <div className="mt-8 h-px bg-background-200" />

            <ul className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-5">
              {CONTACT_DETAILS.map((item) => (
                <li key={item.label} className="flex items-start gap-4">
                  <span className="w-10 h-10 shrink-0 flex items-center justify-center rounded-md bg-primary-100 text-primary-700 text-lg">
                    <i className={item.icon} />
                  </span>
                  <div>
                    <p className="text-[11px] uppercase tracking-[0.18em] text-foreground-500">
                      {item.label}
                    </p>
                    {item.href ? (
                      <a
                        href={item.href}
                        className="mt-0.5 block text-sm md:text-base font-semibold text-foreground-950 hover:text-primary-600 transition-colors cursor-pointer"
                      >
                        {item.value}
                      </a>
                    ) : (
                      <p className="mt-0.5 text-sm md:text-base font-semibold text-foreground-950">
                        {item.value}
                      </p>
                    )}
                  </div>
                </li>
              ))}
            </ul>

            <div className="mt-8 h-px bg-background-200" />

            <div className="mt-8 flex flex-wrap items-center justify-between gap-6">
              <a
                href="https://www.smilewhitefirst.de"
                target="_blank"
                rel="noopener"
                className="inline-flex items-center gap-3 text-sm font-semibold text-foreground-950 hover:text-accent-600 transition-colors cursor-pointer"
              >
                <span className="w-10 h-10 shrink-0 flex items-center justify-center rounded-md bg-accent-100 text-accent-700 text-lg">
                  <i className="ri-sparkling-2-line" />
                </span>
                Smile White First
                <i className="ri-external-link-line text-base text-foreground-500" />
              </a>

              <div className="flex items-center gap-4 text-xs text-foreground-600">
                <Link
                  to="/impressum"
                  className="hover:text-primary-600 transition-colors cursor-pointer"
                >
                  Impressum
                </Link>
                <span className="w-px h-3 bg-background-300" />
                <Link
                  to="/datenschutz"
                  className="hover:text-primary-600 transition-colors cursor-pointer"
                >
                  Datenschutz
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}